import { render, staticRenderFns } from "./privSchoolRoom.vue?vue&type=template&id=30e86962&scoped=true&"
import script from "./privSchoolRoom.vue?vue&type=script&lang=js&"
export * from "./privSchoolRoom.vue?vue&type=script&lang=js&"
import style0 from "./privSchoolRoom.vue?vue&type=style&index=0&id=30e86962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e86962",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
